import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';

import { FinnairCancelEligibility, FinnairOrder } from '@fcom/dapi/api/models';
import { ButtonTheme, ModalButtons } from '@fcom/ui-components';
import { GtmService } from '@fcom/common/gtm';
import { ElementActions, ElementTypes, GaContext } from '@fcom/common';
import { LanguageService } from '@fcom/ui-translate';
import { bookingHasCoverService } from '@fcom/common-booking/utils/common-booking.utils';

@Component({
  selector: 'fin-cancel-booking-modal',
  templateUrl: 'cancel-booking-modal-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CancelBookingModalComponent implements OnInit, OnChanges {
  readonly ModalButtons = ModalButtons;
  readonly ButtonTheme = ButtonTheme;

  @Input() booking: FinnairOrder;
  @Input() isOpen: boolean;

  @Output() modalClosed: EventEmitter<void> = new EventEmitter<void>();

  trackClose = true;
  eligibility: FinnairCancelEligibility;
  hasCoverServicePurchased: boolean;

  constructor(
    private languageService: LanguageService,
    private router: Router,
    private gtmService: GtmService
  ) {}

  ngOnInit(): void {
    this.eligibility = this.booking.eligibilities.voluntaryCancel[0];
    this.hasCoverServicePurchased = bookingHasCoverService(this.booking);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['booking']?.currentValue) {
      this.eligibility = this.booking.eligibilities.voluntaryCancel[0];
      this.hasCoverServicePurchased = bookingHasCoverService(this.booking);
    }
    if (changes['isOpen']?.currentValue) {
      this.gtmService.trackElement(
        'cancel-booking_modal-open',
        GaContext.CANCEL_BOOKING,
        ElementTypes.MODAL,
        undefined,
        ElementActions.OPEN
      );
    }
  }

  navigateToCancelFlow(): void {
    this.trackClose = false;
    this.modalClosed.emit();
    this.gtmService.trackElement(
      'cancel-booking_init-cancel-flow-button',
      GaContext.CANCEL_BOOKING,
      ElementTypes.BUTTON,
      undefined,
      ElementActions.CLICK
    );
    this.router.navigate([this.languageService.langValue, 'manage', 'cancel', 'review']);
  }

  closeModal(shouldTrack = true): void {
    if (this.trackClose && shouldTrack) {
      this.gtmService.trackElement(
        'cancel-booking_modal-close',
        GaContext.CANCEL_BOOKING,
        ElementTypes.MODAL,
        undefined,
        ElementActions.CLOSE
      );
    }

    this.trackClose = true;
    this.modalClosed.emit();
  }
}
